import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

/**
 * @see {@link https://jira.vk.team/browse/CLOUDWEB-19420} Фейкдор в редакторе с мини-иконками
 */
const editorToolbarGroup = getFeature('ab-editor-toolbar-fakedoor') as string | undefined;

export const newEditorToolsEnabled = editorToolbarGroup === 'a';

registerExperiment('editor-toolbar', editorToolbarGroup, [
    AnalyticEventNames.EDITOR_TOOLS_RENAME_CLICK,
    AnalyticEventNames.EDITOR_TOOLS_SEND_ATTACH_CLICK,
]);
